import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NoStorePage: React.FC = () => {
  const navigate = useNavigate()

  function logOut(){
       localStorage.setItem('userData', JSON.stringify(null));
    localStorage.setItem('userid', JSON.stringify(null));
    localStorage.setItem('userId', JSON.stringify(null));
    localStorage.setItem('token', JSON.stringify(null));
    localStorage.setItem('itemSubCategoryId', JSON.stringify(null));
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('userId');
    localStorage.removeItem('userid');
    localStorage.removeItem('token');
    localStorage.removeItem('itemSubCategoryId');
    navigate('/');
  }

  return (
    <Box textAlign="center" mt={10}>
      <Typography variant="h4" color="error" gutterBottom>
        No Store Found
      </Typography>
      <Typography mt={2} mb={2} variant="body1" gutterBottom>
        You currently have no store assigned.
      </Typography>
      <Button variant="contained" onClick={() => logOut()}>
        Sign Out and Return to Login
      </Button>
    </Box>
  )
}

export default NoStorePage;
